import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";

import { fetchRedex } from "../features/redex/redexSlice";

import RedexForm from "./RedexForm";
import RedexTable from "./RedexTable";

function Redex() {

    const dispatch = useDispatch();

    const { loading, error } = useSelector(
        (state) => state.redex
    );

    useEffect(() => {

        dispatch(fetchRedex());

    }, [dispatch]);

    if (loading) {

        return (

            <div className="text-center mt-5">

                <div className="spinner-border text-primary"></div>

            </div>

        );

    }

    if (error) {

        return (

            <div className="alert alert-danger">

                {error}

            </div>

        );

    }

    return (

        <div className="container-fluid mt-3">

            <div className="row">

                <div className="col-lg-4">

                    <RedexForm />

                </div>

                <div className="col-lg-8">

                    <RedexTable />

                </div>

            </div>

        </div>

    );

}

export default Redex;